var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useAlertUiTranslation, useUserState } from '../../../hooks';
const InboxConfigContext = React.createContext({});
/**
 * @deprecated no longer needed, because inbox is a part of alerts now. Properties moved to AlertConfigProvider
 * */
const InboxConfigProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { ready } = useAlertUiTranslation();
    const userState = useUserState();
    const providerValue = Object.assign(Object.assign({}, props), { loginEmail: props.loginEmail ? props.loginEmail(userState) : userState.email });
    return React.createElement(InboxConfigContext.Provider, { value: providerValue }, ready && children);
};
export { InboxConfigProvider };
export default InboxConfigContext;
